import { FC, useEffect, useState } from 'react'
import useClickByKey from '../../hooks/useClickByKey'
import { useHandleField } from '../../hooks/useHandleField'
import { TTrackingState } from '../../hooks/useOrder'
import Button from '../form/Button'
import Input from '../form/Input'
import ShipperSelect from './ShipperSelect'

const defaultTrackingState: TTrackingState = {
  carrier: '',
  trackingNum: '',
}

const TrackingForm: FC<{
  state?: TTrackingState
  errors?: Partial<Record<keyof TTrackingState, string>>
  loading?: boolean
  buttonTitle?: string
  onClick: (state: TTrackingState) => Promise<void>
}> = ({ state, errors, loading, buttonTitle, onClick }) => {
  const [localState, setLocalState] = useState<TTrackingState>(defaultTrackingState)
  const handle = useHandleField(setLocalState)
  const { btnRef, onKeyUp } = useClickByKey()

  useEffect(() => {
    state && setLocalState(() => state)
  }, [state])

  return (
    <div className='w-full grid grid-cols-12 gap-x-5 gap-y-8'>
      <ShipperSelect
        label='Shipper'
        defaultValue={state?.carrier || ''}
        name='carrier'
        type='text'
        size='small'
        value={localState.carrier}
        handle={handle('carrier')}
        error={errors?.carrier}
        disabled={loading}
        className='col-span-6'
        onKeyUp={onKeyUp}
        isError={!!errors?.carrier}
        autoFocus
      />
      <Input
        label='Tracking #'
        name='trackingNum'
        type='text'
        size='small'
        value={localState.trackingNum}
        handle={handle('trackingNum')}
        error={errors?.trackingNum}
        disabled={loading}
        className='col-span-6'
        onKeyUp={onKeyUp}
        isError={!!errors?.trackingNum}
      />
      <div className='col-span-12 flex justify-end'>
        <Button
          btnRef={btnRef}
          disabled={loading}
          isNotFullWidth
          type='submit'
          onClick={() => onClick(localState)}
        >
          {buttonTitle}
        </Button>
      </div>
    </div>
  )
}

export default TrackingForm
